import styled from "@emotion/styled";
import React from "react";
import { sizes } from "../../../../constants/spacing";
import { Spinner } from "../../../spinner";

const LoadingOptionContainer = styled("div")`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: ${sizes.medium}px;
`;

export const LoadingOption = () => {
    return (
        <LoadingOptionContainer aria-hidden={true}>
            <Spinner size="medium" />
        </LoadingOptionContainer>
    );
};
